export default __webpack_public_path__ + "static/media/search.c042c438.svg";